module.exports = __webpack_public_path__ + "assets/img/bedroom_10.3108ec29.jpg";